var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBotao)?_c('span',{staticClass:"text-primary ml-2"},[_c('i',{staticClass:"fa fa-pencil-square-o fa-lg icon-button",attrs:{"title":"Alterar"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('abrirModalBoleto')}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }